'use client';

import { ADMIN_ROUTES } from "@/components/navigation/route.config";
import { Card, CardBody, Chip } from "@nextui-org/react";
import { usePathname } from "next/navigation";

export default function ChildLayout({ children }: { children: React.ReactNode }) {
	// const pathname = usePathname();
	// const knownRoute = ADMIN_ROUTES.find(route => route.path === pathname);

	return (
		<>
			{/* <Chip
				size="lg"
				radius="full"
				variant="shadow"
				color="warning"
				className="absolute top-[4.75rem] left-8 z-[39] text-white text-xl font-bold py-5 px-2 shadow-sm"
			>
				<div className="flex items-center gap-2">
					{knownRoute?.icon}
					{knownRoute?.title}
				</div>
			</Chip> */}
			{/* this is being done to load the classes of tailwind for toast */}
			<span className="
				hidden w-80
				text-slate-700 text-gradient-to-br from-slate-500 to-slate-600
				text-teal-700 bg-gradient-to-br from-teal-200 to-teal-500
				text-amber-700 bg-gradient-to-br from-amber-200 to-yellow-500
				text-emerald-100 bg-gradient-to-br from-emerald-500 to-emerald-700
				text-rose-900 bg-gradient-to-br from-rose-400 to-rose-500
			"
			></span>
			{children}
		</>
	);
}
